<div class="d-flex justify-content-center align-items-center vh-100" id="main">
    <h1 class="mb-0 me-2 pe-3 fw-bold align-top border-end d-inline-block align-content-center">404</h1>
    <div class="d-inline-block align-middle">
        <h2 class="mb-0 fw-light" id="desc">The page you requested was not found.</h2>
        <a href="#" (click)="goBack()">Go Back</a>
    </div>
</div>
